import React from 'react';
import { Users } from 'lucide-react';
import MainPanel from '../../components/layout/MainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function SettingsTeamsPage() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const teams = data?.workspace?.teams || [];

  return (
    <MainPanel title={t('settingsPages.teamsTitle')} subtitle={t('settingsPages.teamsSubtitle')}>
      {teams.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{t('settingsPages.teamsEmpty')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>{t('settingsPages.teamsEmptyBody')}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {teams.map((tm) => (
            <div
              key={tm.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '14px 18px',
                background: '#1f2229',
                borderRadius: 12,
                border: '1px solid rgba(255,255,255,0.06)',
                color: '#f3f4f6',
              }}
            >
              <Users size={20} color="#9ca3af" />
              <span style={{ fontWeight: 600 }}>{tm.name}</span>
            </div>
          ))}
        </div>
      )}
    </MainPanel>
  );
}
